import { ListItem, Suggestion, SuggestionOptions, InverseIndexValuesMap } from './types';

import { QueryManager } from '.';

export function computeSuggestions<ListType extends ListItem = ListItem>(
  data: Map<string, ListType>,
  index: InverseIndexValuesMap,
  options: SuggestionOptions,
  queryManager: QueryManager,
): Suggestion[] {
  if (!options.max) {
    options.max = 20;
  }
  const suggestions: Suggestion[] = [];

  const relevantSearchTerm = options.transform
    ? queryManager.transformValue(options.value, options.transform)
    : options.value;

  for (const [key, value] of index.entries()) {
    const isRelevantAttributeIndex = value.some((item) => data.has(item));

    const relevantKey = options.transform ? queryManager.transformValue(key, options.transform) : key;

    if (options.excludeUndefineds && typeof key === 'undefined') {
      continue;
    }

    if (options.excludeNulls && key === null) {
      continue;
    }

    if (isRelevantAttributeIndex && (relevantSearchTerm === '' || relevantSearchTerm === '//')) {
      const suggestion: Suggestion = {
        value: key,
        keys: options.calculateResultKeys ? value : [],
      };
      suggestions.push(suggestion);
    } else if (isRelevantAttributeIndex && queryManager.queryFind(relevantKey, relevantSearchTerm, 'some')) {
      const suggestion: Suggestion = {
        value: key,
        keys: options.calculateResultKeys ? value : [],
      };
      suggestions.push(suggestion);
    }
    if (suggestions.length === options.max) {
      break;
    }
  }

  return suggestions;
}
